import { Divider, Image, Box, Text } from '@chakra-ui/react';
import React from 'react';
import { WishlistProductProps } from '../../interfaces/components';
import { Trash } from '../../Icons/Trash';

function WishlistProduct({
  width,
  activeLocale,
  productImage,
  productName,
  productMetric,
  productPrice,
  productCurrency,
  removeFromWishlist,
}: WishlistProductProps) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      h={['40px', '60px', '60px']}
      width={width ? width : ['180px', '230px', '230px', '230px', '230px']}
      m="0 auto"
      _notLast={{ marginBottom: '20px' }}
    >
      <Image src={productImage} h={['50px', '60px', '60px']} w={['50px', '60px', '60px']} />
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="column"
        h={['50px', '60px', '60px']}
        w={['120px', '160px', '160px', '160px', '160px']}
      >
        <Text
          noOfLines={2}
          fontSize={['12px', '13px', '14px', '14px', '15px']}
          lineHeight={['13px', '14px', '15px', '15px', '16px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
          textAlign={activeLocale === 'ar' ? 'right' : 'left'}
        >
          {productName}
        </Text>
        <Box>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" justifyContent="flex-start">
              <Text fontSize={['12px', '13px', '14px', '14px', '15px']} fontFamily={'RalewayMedium'} fontWeight="900">
                {productMetric}
              </Text>
              <Text
                m={['0px 5px', '0px 10px', '0px 10px', '0px 10px', '0px 10px']}
                fontSize={['12px', '13px', '14px', '14px', '15px']}
                fontFamily={'LoccitaneRegular'}
                fontWeight="900"
                color="lightgray"
              >
                {`${productPrice?.split('.')[0]} ${productCurrency}`}
              </Text>
            </Box>
            <Trash boxSize={[4, 4, 4, 4, 4]} onClick={removeFromWishlist} cursor="pointer" />
          </Box>
          <Divider border="1px solid" borderColor="lightgray" />
        </Box>
      </Box>
    </Box>
  );
}

export default WishlistProduct;
